import React from 'react';
import type { ViewStyle } from 'react-native';
import { Text, View, ActivityIndicator, LayoutAnimation } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface CtaProps {
	label: string;
	buttonStyle?: string;
	labelColor?: string;
	upperCase?: boolean;
	isLoading?: boolean;
	disabled?: boolean;
	fontSize?: number;
	style?: ViewStyle;
}

export default function Cta({
	label,
	buttonStyle,
	labelColor,
	upperCase,
	isLoading,
	disabled,
	fontSize,
	style,
}: CtaProps) {
	LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
	// A button that is loading or explicitly disabled reads as inactive: dimmed (and the wrapping touchable
	// should also be disabled so it is no longer pressable).
	const inactive = disabled === true || isLoading === true;
	return (
		<View style={[getButtonStyle(buttonStyle), style, inactive ? { opacity: 0.5 } : null]}>
			<Text
				style={{
					color: labelColor,
					fontSize: fontSize ?? Dimens.fontSize14,
				}}
			>
				{upperCase ? (label ?? '').toUpperCase() : label}
			</Text>
			{isLoading === true ? (
				<ActivityIndicator
					color={Colors.white}
					size="small"
					style={{
						width: 16,
						height: 16,
						marginLeft: Dimens.margin15,
						marginRight: Dimens.margin15,
					}}
				/>
			) : null}
		</View>
	);
}

function getButtonStyle(style?: string): ViewStyle {
	const buttonStyle: ViewStyle = {
		paddingVertical: 17,
		paddingHorizontal: Dimens.padding15,
		minWidth: 130,
		borderRadius: 1,
		marginLeft: Dimens.margin15,
		marginRight: Dimens.margin5,
		marginBottom: Dimens.margin15,
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'row',
	};

	switch (style) {
		case 'primary':
			buttonStyle.backgroundColor = Colors.secondary;
			break;
		case 'primaryBordered':
			buttonStyle.backgroundColor = Colors.white;
			buttonStyle.borderWidth = Dimens.borderWidth1;
			buttonStyle.borderColor = Colors.secondary;
			break;
		case 'secondary':
			buttonStyle.backgroundColor = Colors.lightGrey;
			break;
		case 'secondaryBordered':
			buttonStyle.backgroundColor = Colors.lightGrey;
			buttonStyle.borderWidth = Dimens.borderWidth1;
			buttonStyle.borderColor = Colors.lightGrey;
			break;
		case Colors.transparent:
			buttonStyle.backgroundColor = Colors.transparent;
			break;
		case undefined:
		default:
			break;
	}
	return buttonStyle;
}
